import React from "react";

import { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../const";

export const RootContext = React.createContext();

function RootProvider({ children }) {

  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try{

        const res = await axios.get(`${API_URL}/api/user/getCurrentUser`, {
          withCredentials: true,
        });
        console.log("useState", res.data.user);
        setUser(res.data.user);
      }catch(err){
        setUser({});
      }
    };
    fetchUser();
  }, []);

  const [isUserAdmin, setIsUserAdmin] = useState(false);

  
  useEffect(() => {
    setIsUserAdmin(!!user?.isAdmin);
  }, [user]);

  const context = {
    user: user,
    setUser: setUser,
    isUserAdmin: isUserAdmin,
    setIsUserAdmin: setIsUserAdmin,
  };

  return (
    <RootContext.Provider value={context}>{children}</RootContext.Provider>
  );
}

export default RootProvider;
